import actions from '../../actionTypes';

export default (loadChildren, loadAreaChildren) => {
  return {
    type: actions.GET_SITES,
    loadChildren,
    loadAreaChildren
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/getSites.js